export * from './useHandleScrollToClickedOfferTarget'
